import * as dtos from "@/models/dtos";
import store from "@/store";
import { Permission } from "./Permission";
import { MainContainer } from "./MainContainer";
import { PermissionMatrix } from "./PermissionMatrix";
import _ from "lodash";
export class PositionUser {
  Permission: any[] = [];
  Permissions: Permission[] = [];
  AvaiablePermissions: Permission[] = [];
  Container: MainContainer;
  Position: dtos.PositionResponse;
  Email = "";
  Firstname = "";
  Lastname = "";
  PermissionId = 0;
  Name = "";
  Id = 0;
  UserId = "";

  constructor(
    user: dtos.ApplicationUserResponse,
    container: MainContainer,
    position: dtos.PositionResponse
  ) {
    this.Position = position;
    this.Firstname = user.firstname;
    this.Lastname = user.lastname;
    this.Email = user.email;
    this.Id = user.id;
    this.PermissionId = user.permissionId;
    this.UserId = user.userId;
    this.Container = container;
    this.setPermissions();
    this.getPermissionMatrix();
  }

  private setPermissions() {
    const userPermissions = this.Position.userPositions.filter((px) => {
      return px.user.userId === this.UserId;
    });

    this.Container.Permissions.forEach((element) => {
      userPermissions.forEach((userPermission) => {
        if (
          element.Id == userPermission.permission.id ||
          element.Name === userPermission.permission.name
        ) {
          this.Permissions.push(element);
        }
      });
    });

    const difference_a1 = this.Permissions.filter(
      (x) => !this.Container.Permissions.includes(x)
    );

    const difference_a2 = this.Container.Permissions.filter(
      (x) => !this.Permissions.includes(x)
    );

    this.AvaiablePermissions = difference_a2;
  }
  getPermissionMatrix(): any[] {
    const permissions = new Array<any>();
    this.AvaiablePermissions.forEach((element) => {
      permissions.push(new PermissionMatrix(element, false));
    });
    this.Permissions.forEach((element) => {
      permissions.push(new PermissionMatrix(element, true));
    });
    this.Permission = _.orderBy(permissions, ["Permission.Id"], ["asc"]);
    return this.Permission;
  }

  saveUserProfile() {
    store.dispatch("updateAccount", this);
  }
  savePermissionsold(matrix: PermissionMatrix[]) {
    //

    const toAdd = matrix
      .filter((px) => {
        return px.IsSelected;
      })
      .map((px) => px.Permission)
      .filter((x) => !this.Permissions.includes(x))
      .map((px) => {
        const payLoad = new dtos.CreateContainerUserPermission();
        payLoad.permissionId = px.Id;
        payLoad.containerId = this.Container.DTO.id;
        payLoad.email = this.Email;
        return payLoad;
      });

    const toDelete = matrix
      .filter((px) => {
        return !px.IsSelected;
      })
      .map((px) => px.Permission)
      .filter((x) => !this.AvaiablePermissions.includes(x))
      .map((px) => {
        const payLoad = new dtos.DeleteContainerUserPermission();
        payLoad.id = this.Id;
        payLoad.containerId = this.Container.DTO.id;
        return payLoad;
      });

    store.dispatch("addContainerUserPermission", toAdd);
    store.dispatch("deleteContainerUserPermission", toDelete);
  }
  savePermissions(matrix: PermissionMatrix[]) {
    //

    const toAdd = matrix
      .filter((px) => {
        return px.IsSelected;
      })
      .map((px) => px.Permission.Id);

    const item = new dtos.UpdateContainerUserPermission();
    item.containerId = this.Container.DTO.id;
    item.email = this.Email;
    item.permissionIds = toAdd;

    store.dispatch("updateContainerUserPermissions", item);
  }

  isUserAdminOrEditor() {
    return (
      this.Permissions.filter((px) => px.Name === "Administrator").length > 0 ||
      this.Permissions.filter((px) => px.Name === "Write").length > 0
    );
  }

  isUserWriter() {
    return this.Permissions.filter((px) => px.Name === "Write").length > 0;
  }

  isUserReader() {
    return this.Permissions.filter((px) => px.Name === "Read").length > 0;
  }
}
